import {Component, computed, ChangeDetectionStrategy} from "@angular/core"
import {InspectorSectionComponent} from "@template-editor/components/inspectors/inspector-section/inspector-section.component"
import {BaseInspectorComponent} from "@template-editor/components/inspectors/base-inspector/base-inspector.component"
import {ListItemComponent} from "@common/components/item/list-item/list-item.component"
import {ValueSlotComponent, SelectionPossibilities} from "@template-editor/components/value-slot/value-slot.component"
import type {MattressCut, MattressCutParameters} from "@cm/mattress-nodes"
import {MaterialReference} from "@cm/template-nodes"
import {MattressMaterialAssignment} from "@cm/mattress-nodes"
import {mattressFabricLayoutSelectionPossibilities} from "@template-editor/components/inspectors/mattress-inspector/common"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-mattress-cut-inspector",
    templateUrl: "./mattress-cut-inspector.component.html",
    styleUrls: ["./mattress-cut-inspector.component.scss"],
    imports: [InspectorSectionComponent, ValueSlotComponent, ListItemComponent],
    standalone: true,
})
export class MattressCutInspectorComponent extends BaseInspectorComponent<MattressCut> {
    readonly $conditions = computed(() => this.$parameters().conditions)

    addCutCondition() {
        this.$node().addCondition(this.$modifyTemplateGraph())
    }

    removeCutCondition(idx: number) {
        this.$node().removeCondition(idx, this.$modifyTemplateGraph())
    }

    readonly conditionSideSelectionPossibilities: SelectionPossibilities<MattressCutParameters["conditions"][0]["side"]> = [
        {name: "Left", value: "left"},
        {name: "Right", value: "right"},
    ]

    readonly $conditionCurveSelectionPossibilities = computed(() => {
        const curves = this.$node().getValidCurvesForCondition()
        return curves.map((curve) => ({name: curve.parameters.name, value: curve}))
    })

    readonly $modifyTemplateGraph = computed(() => ({modifyTemplateGraph: this.sceneManagerService.modifyTemplateGraph.bind(this.sceneManagerService)}))

    onCutMaterialAssignmentChanged($event: unknown) {
        if (!($event === null || $event instanceof MaterialReference)) return
        this.sceneManagerService.modifyTemplateGraph(() => {
            const cut = this.$node()

            if ($event === null) {
                cut.updateParameters({
                    materialAssignment: null,
                })
            } else if (cut.parameters.materialAssignment) {
                cut.parameters.materialAssignment.updateParameters({
                    node: $event,
                })
            } else {
                cut.updateParameters({
                    materialAssignment: new MattressMaterialAssignment({
                        parameters: {
                            node: $event,
                            side: "front",
                        },
                    }),
                })
            }
        })
    }

    readonly mattressFabricLayoutSelectionPossibilities = mattressFabricLayoutSelectionPossibilities
}
